//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { sortBy } from 'lodash-es';
import BlogHero from '~/components/sections/BlogHero';
import Feature from '~/components/feature';
export default {
  components: { BlogHero, Feature },
  async asyncData({ $content, route, error }) {
    try {
      const data = await $content('tools', route.params.slug).fetch();
      // price phycology: largest first, end in 99 rather than 00
      data.plans = sortBy(data.plans, 'price').reverse();
      const item = {
        ...data,
        image: `/img/tools/${data.banner ? 'banners/' : ''}${data.slug}.png`,
      };
      return { item };
    } catch {
      error({ statusCode: 404 });
    }
  },
  data: () => ({
    item: {},
  }),
  head() {
    const image = `${this.$config.BASE_URL}${this.$img(
      this.item.image || '/img/blog.jpg',
      {
        width: 1280,
        height: 630,
      },
    )}`;
    return {
      title: this.item.heading,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.item.description,
        },
        // Open Graph
        { hid: 'og:title', property: 'og:title', content: this.item.title },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.item.description,
        },
        { hid: 'og:type', property: 'og:type', content: 'article' },
      ],
      script: [
        {
          json: {
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: this.item.title,
            description: this.item.description,
            image: {
              '@type': 'ImageObject',
              url: `${this.$config.BASE_URL}${image.image}`,
              width: image.width,
              height: image.height,
            },
          },
          type: 'application/ld+json',
        },
      ],
    };
  },
  methods: {
    price(cost, currency = 'USD') {
      const margin = cost * 2;
      const nines = margin === 0 || margin % 1 !== 0 ? margin : margin - 0.01;
      const price = nines;
      return price.toLocaleString('en-US', {
        style: 'currency',
        currency,
      });
    },
  },
};
